import apiRequest from "../api/apiRequest";
import { apiConfig } from "../config/apiConfig";
import { getBrandDetailsFromBrandJson } from "../util/share";

declare global {
    interface Window {
      g2Data?: any; // Replace `any` with the appropriate type if known
    }
  }
  
export class NextPrev {
    static async init() {
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        const nextPrev  = new NextPrev();
        nextPrev.setNextPrev(brandData);
    }

    private async setNextPrev(brandData: { enable_fte: any; includeTrailingSlash: any; }) {
    const btns: HTMLAnchorElement[] = Array.from(document.querySelectorAll('.pagination-link'));

    let pathname = window.location.pathname;

    const brandName = (document.getElementById('brandName') as HTMLInputElement)?.value || '';
    const dbaName = (document.getElementById('dbaName') as HTMLInputElement)?.value || 'none';
    const countryCode = (document.getElementById('countryCode') as HTMLInputElement)?.value;

    const sortingBlog = "&sort=custom_dt_modified desc";
    const content = sessionStorage.getItem('blog_search') ?? this.blogSearchTerm();
    const category = sessionStorage.getItem('blog_category');

    let url = this.buildBaseUrl(brandName, dbaName, sortingBlog);

    if (brandData?.enable_fte) {
        url = this.appendBrandFilters(url, countryCode, category, content);

        this.handleBlogSearchPersistence();

        if (window?.g2Data) {
            const blogCategory = this.initBlogArticlePage();
            sessionStorage.setItem('blog_category', blogCategory);
        }
    }
    if (btns.length < 2) return;

    try {
        const docs = await this.getBlogDocs(url);

        if (brandData?.includeTrailingSlash) {
            pathname = pathname.replace(/\/$/, '');
        }

        this.updatePaginationButtons(btns, docs, pathname);
    } catch (err) {
        console.error(err);
    }
    }

    private buildBaseUrl(brandName: string, dbaName: string, sortingBlog: string): string {
        return `${apiConfig.BLOG_URL}${process.env.Search_G2_URL}/select?q=custom_s_brand:${brandName}&rows=1000${sortingBlog}&echoParams=explicit&fl=*,score&defType=edismax&wt=json&fq=custom_s_opus_version:2&fq=custom_s_local_dba:${dbaName}&fq=custom_s_type:blog&fq=custom_s_status:Active`;
    }

    private appendBrandFilters(
        url: string,
        countryCode?: string,
        category?: string | null,
        content?: string | null
    ): string {
        if (countryCode) {
            url += `&fq=custom_s_country:${countryCode}`;
        }
        if (category && category !== 'none') {
            url += `&fq=custom_ss_category:(*${category}*)`;
            sessionStorage.removeItem('blog_search');
        }
        if (category === 'none' && content) {
            // Add space instead of hyphen for search term
            let splitContent = content.split('-');
            content = splitContent.join(' ');
            url += `&fq=content:${content}${splitContent.length == 1 ? '*' : ''}`
        }
        return url;
    }

    private handleBlogSearchPersistence() {
        const updatedURL = new URL(window.location.href);
        const brandDetails = localStorage.getItem("brandDetails");
        let localBlogUrlName = "blog";
        try {
            if (brandDetails) {
                localBlogUrlName = JSON.parse(brandDetails)?.brand_local_blog_url_name || "blog";
            }
        } catch {
            localBlogUrlName = "blog";
        }
        if (updatedURL.pathname.replace(/\//g, '') === localBlogUrlName.replace(/\//g, '')) {
            sessionStorage.removeItem('blog_search');
        }
    }

    private async getBlogDocs(url: string): Promise<any[]> {
        const response: any = await apiRequest({ method: 'GET', url });
        const { docs = [] } = response?.response ?? {};
        return docs;
    }

    private updatePaginationButtons(
        btns: HTMLAnchorElement[],
        docs: any[],
        pathname: string
    ) {
        const index = docs.findIndex((x: any) => x.custom_s_context_url.replace(/\/$/, '') === pathname);

        if (index === -1) return;

        this.setPrevNextButton(btns, docs, index);
    }

    private setPrevNextButton(btns: any[], docs: any[], index: number) {
        if (index !== -1) {
            if (index > 0) {
                btns[0].href = docs[index - 1].custom_s_context_url;
            }

            if (index == 0) {
                btns[0].disabled = true
                btns[0].style.opacity = '0.3'
            }

            if (index < docs.length - 1) {
                btns[1].href = docs[index + 1].custom_s_context_url;
            }

            if (index == docs.length - 1) {
                btns[1].disabled = true
                btns[1].style.opacity = '0.3'
            }
        }
    }


    public blogSearchTerm() {
        const url = window.location.href
        const urlObj = new URL(url);
        // Split the pathname and find the search term
        const pathSegments = urlObj.pathname.split('/');
        const searchIndex = pathSegments.indexOf('search');
        let searchTerm = null;

        if (searchIndex !== -1 && pathSegments[searchIndex + 1]) {
            searchTerm = pathSegments[searchIndex + 1];
            sessionStorage.setItem('blog_search', searchTerm);
        } 
        return searchTerm;
    }

    public initBlogArticlePage() {
        const url = window.location.href;
        const categoryRegex = /\/category\/[\s\-a-zA-Z0-9]+\/?/gim;
        const matchedCategory = url.match(categoryRegex) || ["/category/none"];
        const category = matchedCategory[0].split("/category/")[1].replace("/", "")//.replace(/-/g, ' '); // remove the trailing slash and replace with space
        return category;
    }

}

document.addEventListener('DOMContentLoaded', function() {
    NextPrev.init();
})
